import { AppStoreInfo } from 'types/marketing-site';

const appleAppStoreLink =
	'https://www.fundrise.com/app-store-redirect?utm_source=fundrise&utm_medium=website&utm_campaign=site_reviews';

export const appleAppStoreInfo: AppStoreInfo = {
	buttonSvgAlt: 'Download on Apple app store',
	buttonSvg: 'logo-appstore-white',
	logoSvg: 'logo-apple',
	reviewCount: '35.3k',
	reviewStars: '4.8',
	storeUrl: appleAppStoreLink
};

const googlePlayStoreLink =
	'https://www.fundrise.com/play-store-redirect?utm_source=fundrise&utm_medium=website&utm_campaign=site_reviews';

export const googlePlayStoreInfo: AppStoreInfo = {
	buttonSvgAlt: 'Get it on Google play',
	buttonSvg: 'logo-googleplay-white',
	logoSvg: 'logo-google',
	reviewCount: '6.18k',
	reviewStars: '4.7',
	storeUrl: googlePlayStoreLink
};

export const appStoreInfo: AppStoreInfo[] = [appleAppStoreInfo, googlePlayStoreInfo];
